export const ValueSelectArrows = (props: React.ComponentProps<"svg">) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Select Arrows"
    {...props}
  >
    <path
      d="M6.19742 10.8682C6.36478 11.0439 6.63656 11.0439 6.80392 10.8682L9.37448 8.16872C9.54184 7.99297 9.54184 7.70756 9.37448 7.53181C9.20713 7.35606 8.93535 7.35606 8.76799 7.53181L6.5 9.91353L4.23201 7.53322C4.06465 7.35747 3.79287 7.35747 3.62552 7.53322C3.45816 7.70896 3.45816 7.99438 3.62552 8.17012L6.19608 10.8696L6.19742 10.8682Z"
      fill="currentColor"
    />
    <path
      d="M6.80258 2.13181C6.63522 1.95606 6.36344 1.95606 6.19608 2.13181L3.62552 4.83128C3.45816 5.00703 3.45816 5.29244 3.62552 5.46819C3.79287 5.64394 4.06466 5.64394 4.23201 5.46819L6.5 3.08647L8.76799 5.46678C8.93535 5.64253 9.20713 5.64253 9.37448 5.46678C9.54184 5.29104 9.54184 5.00562 9.37448 4.82988L6.80392 2.1304L6.80258 2.13181Z"
      fill="currentColor"
    />
  </svg>
);
